import bnc                 from "bnc";

export const block = new bnc("smt-answer-widget");
